export const isStorybook = (): boolean => process.env.STORYBOOK === 'true';
